import React from 'react';
import { MenuItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { Stop as StopIcon } from '@material-ui/icons';
export function ProfileMenuItem(_a) {
    var action = _a.action, Icon = _a.icon, label = _a.label, closeDropdownAfterClick = _a.closeDropdownAfterClick, closeDropdown = _a.closeDropdown;
    function onClick(event) {
        action(event);
        if (closeDropdownAfterClick && closeDropdown) {
            closeDropdown();
        }
    }
    return (React.createElement(MenuItem, { onClick: onClick },
        React.createElement(ListItemIcon, { style: { minWidth: '33px' } }, Icon ? (React.createElement(Icon, { color: "primary" })) : (React.createElement(StopIcon, { color: "primary", style: { display: 'none' } }))),
        React.createElement(ListItemText, { primary: label })));
}
//# sourceMappingURL=ProfileMenuItem.js.map